<template>
  <div style="width: 100%; padding: 40px 0 20px 0">
    <div class="container">
      <div style="width: 100%; height: 100%; position: relative">
        <div class="template">
          <div class="title">
            衡水市{{ dimension && dimension.stageName }}毕业生综合素质评价报告书
          </div>

          <div class="table-container">
            <table cellpadding="6">
              <tr>
                <td colspan="2">姓名</td>
                <td colspan="2">{{ dimension && dimension.studentName }}</td>
                <td colspan="2">性别</td>
                <td colspan="2">{{ dimension && dimension.gender }}</td>
                <td colspan="2">民族</td>
                <td colspan="2">{{ dimension && dimension.nation }}</td>
              </tr>
              <tr>
                <td colspan="2">学籍号</td>
                <td colspan="10">{{ "" }}</td>
              </tr>
              <tr>
                <td colspan="2">身份证号</td>
                <td colspan="10">{{ dimension && dimension.idCard }}</td>
              </tr>
              <tr>
                <td colspan="2">毕业学校</td>
                <td colspan="6">{{ dimension && dimension.schoolName }}</td>
                <td colspan="2">班级</td>
                <td colspan="2">{{ dimension && dimension.className }}</td>
              </tr>
              <tr>
                <td colspan="12">
                  {{ dimension && dimension.stageName }}毕业综合素质评价结果
                </td>
              </tr>
              <tr>
                <td colspan="2" class="border-none-right">评价维度</td>
                <td
                  colspan="10"
                  rowspan="2"
                  style="padding: 0"
                  class="border-none-left"
                >
                  <table
                    class="border-none"
                    style="height: 100%; width: 100%; margin: 0"
                  >
                    <tr
                      class="border-none"
                      style="height: 50%"
                      v-if="dimension && dimension.indicatorsNames"
                    >
                      <td
                        class="border-none border-left border-bottom"
                        v-for="item in dimension.indicatorsNames"
                        :key="item"
                      >
                        {{ item }}
                      </td>
                    </tr>
                    <tr
                      class="border-none"
                      style="height: 50%"
                      v-if="!(dimension && dimension.indicatorsNames)"
                    >
                      <td
                        class="border-none border-left border-bottom"
                        v-for="item in ['']"
                        :key="item"
                      >
                        {{ item }}
                      </td>
                    </tr>
                    <tr
                      class="border-none"
                      v-if="dimension && dimension.indicatorsValues"
                    >
                      <td
                        class="border-none border-left border-bottom"
                        v-for="(item, index) in dimension.indicatorsValues"
                        :key="'indicatorsValues' + index"
                      >
                        {{ item }}
                      </td>
                    </tr>
                    <tr
                      class="border-none"
                      v-if="!(dimension && dimension.indicatorsValues)"
                    >
                      <td
                        class="border-none border-left border-bottom"
                        v-for="item in ['']"
                        :key="item"
                      >
                        {{ item }}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="border-none-right">评价结果</td>
              </tr>
              <tr style="max-height: 150px">
                <td colspan="2">
                  <span
                    style="
                      text-align: center;
                      display: inline-block;
                      width: 12px;
                      line-height: 1.4vw;
                    "
                    >综合性评语</span
                  >
                </td>
                <td
                  colspan="10"
                  style="padding: 15px; line-height: 14px; text-align: left"
                >
                  <span class="overflow-span">{{
                    dimension && dimension.evalTeacher
                  }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="12">班级评价工作小组成员签名</td>
              </tr>
              <tr style="max-height: 150px; position: relative">
                <td colspan="12">
                  <span style="position: absolute; right: 80px"
                    >时间：&emsp;&emsp;年&emsp;月&emsp;日</span
                  >
                </td>
              </tr>
              <tr>
                <td colspan="12">学校评价工作委员会成员签名</td>
              </tr>
              <tr style="max-height: 150px; position: relative">
                <td colspan="12">
                  <span style="position: absolute; right: 80px"
                    >时间：&emsp;&emsp;年&emsp;月&emsp;日</span
                  >
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dimension'],

  components: {},

  data () {
    return {

    }
  },

  watch: {

  },

  computed: {

  },

  mounted () {

  },

  methods: {

  }
}
</script>

<style lang="scss" scoped>
.template {
  max-width: 100%;
  height: calc(100% - 95px);
  position: absolute;
  padding: 45px 50px 50px 50px;
  margin: 0 auto;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.18),
    0px 2px 8px 0px rgba(0, 0, 0, 0.18);
}
.title {
  font-size: 20px;
  font-family: monospace;
  font-weight: bold;
  height: 28px;
  line-height: 28px;
  text-align: center;
}
.table-container {
  width: 100%;
  height: calc(100% - 28px);
  max-height: calc(100% - 28px);
  display: flex;
  justify-content: center;
}
table {
  height: 100%;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 12px;
  font-family: STSongti-SC-Regular, STSongti-SC;
}
table,
tr,
td {
  border: 0.3px solid black;
  text-align: center;
  vertical-align: middle;
}
// tr {
//   height: 31px;
// }
td {
  word-wrap: break-word;
  word-break: break-all;
}
.border-none {
  border: 0;
}
.border-none .border-bottom {
  border-bottom: 0.5px solid black;
}
.border-none .border-bottom-white {
  border-bottom: 1px solid #00000000;
}
.border-none .border-left {
  border-left: 0.5px solid black;
}
.border-none-right {
  border-right: 0;
}
.border-none-left {
  border-left: 0;
}
.container {
  box-sizing: border-box;
  width: 21cm;
  height: 29.7cm;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.overflow-span {
  word-break: normal;
  display: block;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/common/GraduateTemplate.vue